<template>
  <main id="container" class="page-container bg-wave5">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="이벤트" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-delivery">
      <div class="container">
        <div class="page-sub-header">
          <h3 class="page-sub-title">
            <span class="green">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3>
        </div>
      </div>
      <in-ready/>
    </div>
  </main>
</template>
<style>
.accept-button a {
  width: 80px; /* 버튼 너비 유지 */
  height: 25px; /* 버튼 높이 유지 */
  border-radius: 7px;
  display: inline-flex;
  background-color: #78c3f5;
  color: #ffffff;
  font-size: 17px;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
}

.infolist-text-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
}

.infolist-text-wrapper .infolist-title {
  margin-top: 17px;
  margin-left: 15px;
  flex-shrink: 0;
  text-decoration: none;
}

.prect-list-text a {
  word-break: break-all;
}

@media (max-width: 768px) {
  .infolist-text-wrapper .infolist-title {
    margin-left: 11px;
  }
  .desclist-title,
  .desclist-text,
  .desclist-text-small,
  .desclist-text-bold {
    font-size: 16px !important;
  }
}
</style>
<script>
import PageHeader from "@/components/content/PageHeader";
import InReady from '@/components/common/InReady';
export default {
  name: "EventDelivery",
  components: { PageHeader , InReady},
  data: () => ({
    visibleModal: false,
    infoList: [
      {
        title: "참여기간",
        detail: "2025년 9월 1일(월) ~ 2025년 9월 30일(화)<br>* 베스트리뷰어 : 1주차 9.1~9.7, 2주차 9.8~9.14, 3주차9.15~9.21, 4주차 9.22~9.30",
      },
      {
        title: "결과발표",
        detail: "2025년 11월 중<br>*베스트리뷰어 : 9.12, 9.19, 9.26, 10.2",
      },
      {
        title: "경품발송",
        detail: "2025년 11월 중",
      },
      {
        title: "진행방식",
        detail:
          "공공배달앱 이용 후 앱 내 포토 후기 작성, 캡처 후 네이버폼 접수<br>공공배달앱 찾기 : <a href='https://www.atfis.or.kr/delivery/front/M0000169/app/list.do' target='_blank'>https://www.atfis.or.kr/delivery/front/M0000169/app/list.do</a></span>",
      },
    ],
    prdList: [
      {
        img: "item_gift_certificate.jpg",
        title: "디지털 온누리상품권",
        person: " 50만원 4명",
      },
      {
        img: "item_gift_certificate.jpg",
        title: "디지털 온누리상품권",
        person: "10만원 10명",
        person2: "5만원 20명",
        person3: "1만원 30명",
      },
      {
        img: "item_chicken.jpg",
        title: "치킨+콜라 쿠폰",
        person: "(20명)",
      },
      {
        img: "item_coffee.png",
        title: "커피 쿠폰",
        person: "(60명)",
      },
    ],
    deliveryInfo: [
      "네이버폼 접수자 대상 미션 검수 후, 추첨을 통해 당첨자 선정",
    ],
    deliveryList: [
      "5만원 이하 경품 : 네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
      "5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내와 개인정보, 고유식별정보 수집·이용 및 제공 동의 → 제세공과금 납부 확인 후 네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
    ],

    prectList: [
      "본 이벤트는 동행축제 기간 내 공공배달앱 이용 포토 후기 작성 후 동행축제 누리집 또는 카카오톡 채널 이벤트 페이지 내 네이버 폼에 접수해 주시면 응모 완료됩니다.",
      '해당 이벤트에 만 14세 미만은 참여할 수 없습니다. (만 14세 미만 참여자의 경우 경품 당첨이 취소됩니다.)',
      '<span style="color: red;">작성일자 보이게 캡처 필수, 이벤트 기간 내 이용 후기만 미션으로 인정됩니다.',
      '베스트리뷰어 선정 시 네이버폼에 접수한 리뷰 이미지가 홍보물로 사용됩니다.',
      "이벤트 내 중복 당첨은 불가하며, 베스트리뷰어 당첨이 안 될 경우 일반리뷰어 추첨으로 포함됩니다.",
      "5만원 초과 경품 당첨의 경우 제세공과금(22%)는 본인 부담해야 합니다",
      '<span style="color: red;">디지털 온누리상품권의 경우 디지털온누리앱에 가입한 자에게 선물하기를 통해 경품 지급될 예정입니다.</span> <br>*구글플레이스토어 : <a href="https://play.google.com/store/apps/details?id=com.komsco.kpay" target="_blank">https://play.google.com/store/apps/details?id=com.komsco.kpay</a><br>*앱스토어 : <a href="https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450" target="_blank">https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450</a>',
      '<span style="color: red;">이름과 휴대폰 번호가 디지털온누리앱 가입 정보와 일치한 경우에만 선물을 받을 수 있습니다.',
      "당첨자의 잘못된 정보 입력으로 인해 경품 누락 될 경우 재발송되지 않습니다.",
      "지급된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.",
      "당첨 쿠폰이 분실 및 도난 된 경우, 재발송 불가합니다. (당첨 쿠폰 복사 및 저장 필수)",
      "이벤트 참여 응모를 위한 네이버폼으로 취합 된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기됩니다.",
      "이벤트 일정 및 경품 내역은 추후 주최 측의 사정에 따라 변동 가능합니다.",
      '이벤트에 관한 문의는 대행사인 <span style="font-weight: bold;">㈜지엠컴 070-4838-6391</span>로 문의 바라며, 상담 가능 시간은 평일 오전 10시 ~ 오후 7시입니다.',
    ],
  }),
  computed: {
    isShowBtn() {
      return new Date() > new Date("2025-09-01 00:00:00") &&
        new Date() < new Date("2025-09-30 23:59:59");
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const thisTab = document.querySelector(".tab-button.is-active");
        thisTab.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    });
  },
  methods: {
    clickLink(url) {
      window.open(url, "_blank");
    },
    clickEvent(e) {
      let url = "https://naver.me/5neaoDUO";
      const w = 560;
      const h = 600;
      const title = "이벤트";

      // 브라우저 창의 크기 가져오기
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      // 팝업창의 중앙 좌표 계산
      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;

      // 팝업창 설정
      const options = `
				scrollbars=yes,
				width=${w},
				height=${h},
				top=${top},
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, "");

      // 팝업창 열기
      const newWindow = window.open(url, title, options);

      // 팝업창이 차단되었는지 확인
      if (window.focus && newWindow) {
        newWindow.focus();
      }

      return newWindow;
    },
  },
  metaInfo() {
    return {
      title: "공공배달앱 이벤트 | 동행축제",
      link: [
        {
          rel: "canonical",
          href: "https://www.k-shoppingfesta.org/ko/event/delivery",
        },
        {
          rel: "alternate",
          hreflang: "ko",
          href: "https://www.k-shoppingfesta.org/ko/event/delivery",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://www.k-shoppingfesta.org/ko/event/delivery",
        },
      ],
    };
  }
};
</script>
